import { Button } from "@shadcn-in-nx/ui/button";
import { useTranslation } from "react-i18next";

export function PauseSolution({ onPause, onStillCancel, isPausing }) {
    const { t } = useTranslation();

    return (
        <div className="space-y-6">
            <div className="text-center">
                <div className="text-4xl mb-4">⏸️</div>
                <h3 className="text-xl font-bold mb-2">{t("billing.supportPlans.cancel.takeBreak")}</h3>
                <p className="text-muted-foreground">
                    {t("billing.supportPlans.cancel.pauseDescription")}
                </p>
            </div>
            <div className="grid grid-cols-2 gap-4">
                <Button onClick={onPause} disabled={isPausing} className="bg-blue-600 hover:bg-blue-700 text-white">
                    {isPausing ? t("billing.supportPlans.cancel.pausing") : t("billing.supportPlans.cancel.pauseSubscription")}
                </Button>
                <Button onClick={onStillCancel} variant="outline" disabled={isPausing}>
                    {t("billing.supportPlans.cancel.stillCancel")}
                </Button>
            </div>
        </div>
    );
}

export function SupportSolution({ onContactSupport, onStillCancel }) {
    const { t } = useTranslation();

    return (
        <div className="space-y-6">
            <div className="text-center">
                <div className="text-4xl mb-4">💬</div>
                <h3 className="text-xl font-bold mb-2">{t("billing.supportPlans.cancel.letUsHelp")}</h3>
                <p className="text-muted-foreground">
                    {t("billing.supportPlans.cancel.helpDescription")}
                </p>
            </div>
            <div className="grid grid-cols-2 gap-4">
                <Button onClick={onContactSupport} className="bg-blue-600 hover:bg-blue-700 text-white">
                    {t("billing.supportPlans.cancel.talkToSupport")}
                </Button>
                <Button onClick={onStillCancel} variant="outline">
                    {t("billing.supportPlans.cancel.stillCancel")}
                </Button>
            </div>
        </div>
    );
}
